export interface ChannelOptionLike {
  id: string;
  name: string;
  categoryName?: string | null;
}

const getCategorySortKey = (channel: ChannelOptionLike) =>
  (channel.categoryName ?? "").toLowerCase();

const getChannelSortKey = (channel: ChannelOptionLike) =>
  channel.name.toLowerCase();

export const sortChannelsByCategoryAndName = <T extends ChannelOptionLike>(
  channels: T[] | undefined | null,
): T[] => {
  if (!channels || channels.length === 0) {
    return [];
  }

  return [...channels].sort((a, b) => {
    const categoryComparison = getCategorySortKey(a).localeCompare(
      getCategorySortKey(b),
    );
    if (categoryComparison !== 0) {
      return categoryComparison;
    }
    return getChannelSortKey(a).localeCompare(getChannelSortKey(b));
  });
};

export const formatChannelOptionLabel = (
  channel?: ChannelOptionLike | null,
): string => {
  if (!channel) {
    return "Unknown channel";
  }
  const channelName = `#${channel.name}`;
  return channel.categoryName
    ? `${channel.categoryName} / ${channelName}`
    : channelName;
};
